import axios from 'axios';
import { useQuery } from 'react-query';

export const queryKeys = {
  detail: ['app-config', 'detail'],
};

export const appConfig = () => axios.get<BonjoroStatic>('/api/v3/app-config');

export const useAppConfig = (options?: Record<string, unknown>) =>
  useQuery(
    queryKeys.detail,
    async () => {
      const res = await appConfig();

      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      initialData: window.Bonjoro,
      ...options,
    }
  );
